"use client";

import Link from "next/link";
import { motion, useAnimation } from "framer-motion";
import { CtaComponentProps } from "@/cms/models";
import {
  getBorderRadius,
  getDesktop,
  getDesktopSize,
  getMargins,
  getMobile,
  getMobileSize,
  getPaddings,
} from "@/utils/theme-helper";

const CtaComponent: React.FC<{
  config: CtaComponentProps;
  id: string;
  itemIndex: number;
}> = ({ config, id, itemIndex }) => {
  const controls = useAnimation();

  const mobileWidth = getMobile("none", config.width);
  const desktopWidth = getDesktop("none", config.width);
  const mobileHeight = getMobile("none", config.height);
  const desktopHeight = getDesktop("none", config.height);

  let disableAnimation = config.disableAnimation;
  // Temp always disable animation
  disableAnimation = true;

  return (
    <div
      data-type="CtaComponent"
      className={`flex md:homepage-text-${getDesktopSize(config?.size)} homepage-text-${getMobileSize(config?.size)} ${getMargins(config.margin)} justify-${config.justify} ${mobileWidth !== "none" ? "w-[var(--mobile-width)]" : ""} ${desktopWidth !== "none" ? "md:w-[var(--desktop-width)]" : ""} ${mobileHeight !== "none" ? "h-[var(--mobile-height)]" : ""} ${desktopHeight !== "none" ? "md:h-[var(--desktop-height)]" : ""}`}
      style={
        {
          "--mobile-width": mobileWidth,
          "--desktop-width": desktopWidth,
          "--mobile-height": mobileHeight,
          "--desktop-height": desktopHeight,
        } as React.CSSProperties
      }
    >
      <motion.div
        initial={disableAnimation ? undefined : "initial"}
        whileInView={disableAnimation ? undefined : "animate"}
        animate={disableAnimation ? undefined : controls}
        className={id}
        viewport={{
          once: true,
        }}
        variants={{
          initial: {
            opacity: 0,
            y: 100,
          },
          animate: () => ({
            opacity: 1,
            y: 0,
            transition: {
              delay: 0.05 * itemIndex,
            },
          }),
        }}
      >
        <Link
          href={config.link}
          style={
            {
              "--cta-text-color": config.textColor,
              "--cta-bg-color": config.bgColor,
              "--cta-border-color": config.borderColor,
              "--cta-hover-border-color": config.hoverBorderColor,
              "--cta-hover-bg-color": config.hoverBgColor,
              "--cta-hover-text-color": config.hoverTextColor,
              "--rounding-mobile": getBorderRadius(
                getMobile("", config.rounded)
              ),
              "--rounding-desktop": getBorderRadius(
                getDesktop("", config.rounded)
              ),
            } as React.CSSProperties
          }
          className={`homepage-rounded border border-[var(--cta-border-color)] hover:border-[var(--cta-hover-border-color)] ${config.padding ? getPaddings(config.padding) : "px-3 py-2"} hover:text-[var(--cta-hover-text-color)] hover:bg-[var(--cta-hover-bg-color)]  bg-[var(--cta-bg-color)] text-[var(--cta-text-color)] flex justify-center lg:min-w-[122px] text-${getMobileSize(config.size)} md:text-${getDesktopSize(config.size)}`}
        >
          {config.label}
        </Link>
      </motion.div>
    </div>
  );
};

export default CtaComponent;
